@import '../../responsive/responsive-mixin';

$sizes: 1024, 0;

ui-download-search {
  @include responsive($sizes);

  display: block;
  position: relative;

  ui-headline {
    margin-bottom: 24px;
  }

  ui-container {
    overflow: visible; // needed to show autosuggestion completely
  }

  .fundsText {
    margin-top: 36px;
  }
}
